
<div fxLayout="column" fxFill>
  <div>
    <mat-toolbar class="mini-header force">
      <div class="stretch page-title" style="text-align: left">
        <button
          mat-button
          (click)="onUploadDrivers()"
          style="color: white; margin: 0 5px 0 5px"
          class="top-buttons"
          [style.background-color]="'#' + cService.userProfile?.HqColour"
          [disabled]="!configurationDataAvailable"
        >
          {{ 'DRIVER_IMPORT.importNewDriverData' | translate | uppercase }}
        </button>
        <button
          mat-button
          (click)="onEditConfiguration()"
          style="color: white; margin: 0 5px 0 5px"
          class="top-buttons"
          [style.background-color]="'#' + cService.userProfile?.HqColour"
          [disabled]="!configurationDataAvailable"
          *ngIf='cService.userProfile.userPermissions.permConfigureImportMappings === cService.permLevels.TRUE'
        >
          {{ 'DRIVER_IMPORT.editConfiguration' | translate | uppercase }}
        </button>
      </div>
    </mat-toolbar>
  </div>

  <div fxLayout="column" fxFlex>
    <ag-grid-angular
      #agGrid
      fxFlex
      class="ag-theme-balham"
      [rowData]="rawData"
      [columnDefs]="columnsToDisplay"
      [gridOptions]="gridOptions"
      (gridReady)="agGridReady($event)"
      (columnResized)="gridColumnResized()"
      [components]="customComponents"
    >
    </ag-grid-angular>
  </div>
</div>
